import { styled } from 'styled-components';

import { styledTypography } from '@pkg/primitives';
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    gap: 20px;
    @media (min-width: 768px) {
        gap: 25px;
    }
`;

export const Subtitle = styled.h2`
    ${styledTypography.allianceBase};
    font-size: 30px;
    font-weight: 700;
`;
export const BodyCopy = styled.p`
    ${styledTypography.allianceBase};
    color: ${({ theme }) => theme.shades.white[50]};
    font-weight: 600;
`;
